module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-7-sm-b0f05f1f5219bb0e4e345f4f79da3a95.png";